import * as base from 'utils/bolt/api.js';
export * from 'utils/bolt/api.js';
import Store from 'store/store';


export async function api(endpoint, options = {}, fetchOptions = {}) {
	options.primenights = 'true';
	if (Store.get()?.showtimes?.earlyAccessWindow) {
		options.primenights_early_access_window = 'true';
	}
	return base.api(endpoint, options, fetchOptions);
}
